<template>
  <v-card>
    <v-card-title class="text-subtitle-1">
      Hợp đồng hết hạn 
      <v-divider class="mx-2" vertical></v-divider>
      <v-checkbox label="Hết hạn" v-model="isExpire"></v-checkbox>
      <export-excel :items="items" :headers="headers" :textStyle="true"></export-excel>

      <v-spacer></v-spacer>
      <v-text-field style="max-width: 200px;" v-model="search" placeholder="Tìm kiếm" hide-details outlined dense></v-text-field>
      <v-btn color="orange" icon @click="getResign"> <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-data-table :search="search" :items="items" :headers="headers" fixed-header dense height="500px" 
      :items-per-page="-1"
      :footer-props="{
        'items-per-page-options': [5, 10, 20, 50, -1]
      }">
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import {getResign} from './api'
import ExportExcel from '@/components/ExportExcel'
import formatter from '@/components/services/formatter';

export default {
  name: "ContractExpire",
  components: {
    ExportExcel
  },
  data() {
    return {
      search: "",
      items: [],
      headers: [
      {text: 'Mã NS', align: 'start', value: 'employeeCode'},
      {text: 'Tên NS', align: 'start', value: 'employeeName'},
      // {text: 'Phòng/store', align: 'start', value: 'departmentCode'},
      {text: 'Phòng/store', align: 'start', value: 'departmentName'},
      {text: 'Ngày nhận việc', align: 'start', value: 'hireDate'},
      {text: 'Mã HD', align: 'start', value: 'contractCode'},
      {text: 'ID HD', align: 'start', value: 'contractId'},
      {text: 'Loại', align: 'start', value: 'contractTypeName'},
      {text: 'Ngày ký', align: 'start', value: 'signDate'},
      {text: 'Hết hạn', align: 'start', value: 'expireDate'},
      // {text: 'Hết hạn', align: 'start', value: 'contractTypeCode'},
      ],
      isExpire: true
    }
  },
  methods: {
    getResign() {
      return getResign(this.isExpire).then(d => {
        this.items = d.data.map(x => {
          x.signDate = formatter.formatDate(x.signDate, "DD/MM/YYYY")
          x.expireDate = formatter.formatDate(x.expireDate, "DD/MM/YYYY")
          x.hireDate = formatter.formatDate(x.hireDate, "DD/MM/YYYY")
          return x
        })
      })
    }
  },
  watch: {
    isExpire() {
      this.getResign()
    }
  },
  mounted() {
    this.getResign(this.isExpire).then(d => {
      this.items = d.data.map(x => {
        x.signDate = formatter.formatDate(x.signDate, "DD/MM/YYYY")
        x.expireDate = formatter.formatDate(x.expireDate, "DD/MM/YYYY")
        x.hireDate = formatter.formatDate(x.hireDate, "DD/MM/YYYY")
        return x
      })
    })
  }
}
</script>